<script>
import useSharedData from "@/use/SharedData.js";
import useTools from "@/use/Tools.js";
import useValidation from "@/use/Validation.js";
import useSharedMethod from "@/use/SharedMethod.js";
import {useSecurityStore} from "@/stores/Security";
import axios from "axios";
import {ref} from "vue";

export default {
    setup() {
        const {dialog, loading} = useSharedData();
        const {$route, $refs} = useTools();
        const {mxRules} = useValidation();
        const {getBack, logout} = useSharedMethod();
        const securityStore = useSecurityStore();

        const password = ref(null);
        const confirmPassword = ref(null);

        function change() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.put(`/users/changePasswordByUser/${$route.params.id}`, {password: password.value}).then(() => {
                    if (securityStore.userContext.id === $route.params.id) {
                        logout();
                    } else {
                        getBack();
                    }
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        return {
            mxRules,
            dialog,
            loading,
            password,
            confirmPassword,
            getBack,
            change
        };
    }
};
</script>

<template>
    <v-dialog v-model="dialog" persistent max-width="600" scrollable>
        <v-card>
            <w-toolbar color="purple" :title="$t('user.reset_password')"/>
            <v-card-text>
                <v-container fluid>
                    <v-form ref="form" lazy-validation>
                        <v-row>
                            <v-col cols="12">
                                <w-label :label="$t('common.password')" required/>
                                <w-password-text-field
                                    v-model="password"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                             <v-col cols="12">
                                <w-label :label="$t('common.confirm_password')" required/>
                                <w-password-text-field
                                    v-model="confirmPassword"
                                    :rules="[mxRules.passwordMatch(password)]"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn
                    icon="mdi-lock-reset"
                    :text="$t('user.reset_password')"
                    :loading="loading"
                    color="purple"
                    @press="change"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped></style>